import { FC } from "react"

import icon1 from 'assets/images/icon-calculator.png';
import icon2 from 'assets/images/icon-globe.png';
import icon3 from 'assets/images/icon-music.png';
import icon4 from 'assets/images/icon-paint.png';
import icon5 from 'assets/images/icon-ball.png';
import { useTranslation } from "react-i18next";

const SectionSubjects: FC<{iframe?: boolean}> = ({iframe = false}) => {
  const { t } = useTranslation()

  const list = [
    {image: icon1, color: '#faadad', title: t('dashboard.maths')},
    {image: icon2, color: '#e4c9f9', title: t('dashboard.science')},
    {image: icon3, color: '#aaf1cb', title: t('dashboard.music')},
    {image: icon4, color: '#ffe99d', title: t('dashboard.painting')},
    {image: icon5, color: '#54f892', title: t('dashboard.sports')},
  ]

  return (
    <>
    <div className='section-subjects'>
            {list.map((a, idx) => <div key={idx} >

                <div className='box-shadow section-subjects-item'
                    style={{
                        backgroundColor: a.color,
                        backgroundImage: `url('${a.image}')`,
                    }}>
                      <div style={{ padding: '15px', fontSize: '24px', fontWeight: '800', paddingBottom: '10px', textAlign: 'center' }}>{a.title}</div>
                    </div>
            </div>)}   
        </div>
    </>
  )
}

export default SectionSubjects
